var _style, _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _g, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHermes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "m-logo-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:url(#SVGID_1_);} .st1{fill:url(#SVGID_2_);} .st2{fill:url(#SVGID_3_);} .st3{fill:url(#SVGID_4_);} .st4{fill:url(#SVGID_5_);} .st5{fill:url(#SVGID_6_);} .st6{fill:url(#SVGID_7_);} .st7{fill:url(#SVGID_8_);} .st8{fill:url(#SVGID_9_);} .st9{fill:#3C3C41;}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.912,
    y1: 16.214,
    x2: 29.883,
    y2: 22.051,
    gradientTransform: "matrix(1 0 0 -1 0 22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#646469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#A9A9AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D9D9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBF0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.2 5.7L32.6 0h-3.1l-1.4 5.7"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.947,
    y1: 13.72,
    x2: 23.52,
    y2: 27.627,
    gradientTransform: "matrix(1 0 0 -1 0 22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#CBE4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#96CDE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#68B9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#42A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#259CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#1193C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#048EC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008CC3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.8 5.7L28.2 0H0l4.9 5.7"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.56,
    y1: 22.698,
    x2: 5.16,
    y2: 15.74,
    gradientTransform: "matrix(1 0 0 -1 0 22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#DDECF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    stopColor: "#C5E1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9DD0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#66B8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#209ACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008CC3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.9 5.7L0 0v1.8l4.1 3.9"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.054,
    y1: 8.892,
    x2: 28.024,
    y2: 14.729,
    gradientTransform: "matrix(1 0 0 -1 0 22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#646469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#A9A9AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D9D9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBF0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.3 13.1l1.5-5.7h-3.1l-1.5 5.7"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.554,
    y1: 11.82,
    x2: 26.405,
    y2: 11.82,
    gradientTransform: "matrix(1 0 0 -1 0 22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#C0DEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#86C2DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#56ABCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#3199C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#168DBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#0685B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082B4"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24.9 13l1.5-5.7H7.6l5 5.7"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.548,
    y1: 14.768,
    x2: 12.876,
    y2: 8.867,
    gradientTransform: "matrix(1 0 0 -1 0 22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C7E1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#77BBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082B4"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.6 13l-5-5.7V9l4.3 4.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.194,
    y1: 1.581,
    x2: 26.166,
    y2: 7.415,
    gradientTransform: "matrix(1 0 0 -1 0 22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#646469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#A9A9AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D9D9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBF0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M27.5 20.4l1.5-5.7h-3.1l-1.5 5.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.012,
    y1: 6.207,
    x2: 23.802,
    y2: 4.178,
    gradientTransform: "matrix(1 0 0 -1 0 22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    stopColor: "#C6E0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#80BDD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#49A2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#218EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903,
    stopColor: "#0981B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#007DAF"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M23.1 20.4l1.4-5.7h-9.3l5 5.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.538,
    y1: 7.207,
    x2: 21.057,
    y2: 1.128,
    gradientTransform: "matrix(1 0 0 -1 0 22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#90C5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#439EC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#1386B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DAF"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M20.3 20.4l-5-5.7v1.6l4.3 4.1"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M133.9 4.1l-.5 1.9c-.2.9-.7 1.2-1.7 1.2h-3c-1.3 0-1.8.1-2.1.4-.3.3-.4.7-.4 1.2s.2.7 1 .9l3 .9c2.1.6 2.7 1.2 2.7 2.8 0 1.6-.6 4.1-1.5 5.3-.9 1.1-2 1.6-3.7 1.6h-7.4c-.6 0-.8-.4-.7-.9l.9-3.7h.9c.2.8.8 1.1 2 1.1h2.9c1.1 0 1.6-.2 1.9-.5.3-.3.5-.9.5-1.3 0-.7-.2-.9-1.7-1.2l-3-.8c-1.6-.4-2.3-1.3-2.3-2.6s.6-3.1 1.3-4.3c.8-1.4 2.1-2 4.3-2h6.6zm-66.7 4c0 1.2-.5 3.3-.9 4.1-.3.6-.7.8-2.2.8h-7l-.3 1.3c-.1.3-.1.7-.1 1 0 .6.2 1.1.7 1.4.4.3 1.2.4 2.5.4 2.8 0 3.4-.4 4.3-1.6h.9l-.6 2.2c-.4 1.6-.5 1.9-1.1 2.2-.8.4-2.3.6-4.7.6-2.2 0-3.6-.2-4.4-.6-1.2-.6-1.9-2-1.9-3.8 0-3 1.5-7.6 3-9.5C56.9 4.7 58.8 4 62.1 4c3.6-.1 5.2 1.2 5.1 4.1zm-3.5.5c0-1.2-.7-1.7-2.3-1.7-2.1 0-2.9.8-3.6 3.4h5.6c.2-.8.3-1.2.3-1.7zm55.3-.5c0 1.2-.5 3.3-.9 4.1-.3.6-.8.7-2.3.7h-7l-.3 1.3c-.1.3-.1.7-.1 1 0 .6.2 1.1.7 1.4.4.3 1.2.4 2.5.4 2.8 0 3.4-.4 4.3-1.6h.9l-.6 2.2c-.4 1.6-.5 1.9-1.1 2.2-.8.4-2.3.6-4.7.6-2.2 0-3.6-.2-4.4-.6-1.2-.6-1.9-2-1.9-3.8 0-3 1.5-7.6 3-9.5 1.5-1.9 3.4-2.6 6.7-2.6 3.7 0 5.3 1.3 5.2 4.2zm-3.5.5c0-1.2-.7-1.7-2.3-1.7-2.1 0-2.9.8-3.6 3.4h5.6c.2-.8.3-1.2.3-1.7zM53 .9c.1-.5-.2-.9-.7-.9h-4.5l-.1.6c.8.2.5 1.1.4 1.5-.2.9-1.4 5.4-1.4 5.4h-6.1L42.3.9c.1-.5-.1-.9-.7-.9h-4.5l-.1.6c.8.2.5 1.1.4 1.5-.6 2.7-4.5 17.5-4.5 17.5-.1.4.1.9.7.9h4.5l.1-.6c-.8-.2-.5-1.1-.4-1.5l1.9-7.6h6.1l-2.3 8.8c-.1.4.1.9.7.9h4.5l.1-.6c-.8-.2-.5-1.1-.4-1.5C48.6 18 53 .9 53 .9zM100.2 4H98c-1.1 0-1.7.2-2.4 1.3l-.8 1.3C94.9 5.3 94.2 4 92 4h-2c-1.7 0-2.1.7-2.5 1.2l-.9 1.2L87 5c.1-.4-.1-.9-.7-.9h-4l-.2.6c.4.1.6.4.6.7 0 .2 0 .3-.1.6l-3.5 13.6c-.1.4.1.9.7.9h4l.1-.6c-.4-.1-.5-.4-.5-.6 0-.1 0-.3.1-.7 0 0 2.3-8.5 2.3-8.6.5-2.2 1.1-2.4 2.3-2.6h.8c1.1 0 1.5.7 1.3 1.5 0 .2-2.7 10.8-2.7 10.8-.1.4.1.9.7.9h4l.1-.6c-.4-.1-.5-.4-.5-.6 0-.1 0-.3.1-.7l2.3-8.6c.6-2.2 1.1-2.4 2.3-2.6h.8c1.2 0 1.5.7 1.3 1.5 0 .1-2.7 10.8-2.7 10.8-.1.4.1.9.7.9h4l.1-.6c-.4-.1-.5-.4-.5-.6 0-.1 0-.3.1-.7 0 0 2.7-10.8 2.8-11.3.2-1.3.2-3.5-2.9-3.5zm-22.4.1c-1 0-1.1 0-1.6.7L75 6.4l.4-1.4c.1-.4-.1-.9-.7-.9h-4l-.1.6c.4.1.5.4.5.6 0 .1 0 .3-.1.7l-3.5 13.6c-.1.4.1.9.7.9h4l.1-.6c-.4-.1-.5-.4-.5-.6 0-.1 0-.3.1-.7l2.3-8.7c.5-2 1-2.4 2.8-2.4h1.6c1.2 0 1.6-.3 1.8-1.2l.6-2.1-3.2-.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHermes);
export default __webpack_public_path__ + "static/media/hermes.c26f5cfdc67539d6ffe45357c4a9c7d9.svg";
export { ForwardRef as ReactComponent };